<!--
 * @Description:
 * @Author: Mankeung
 * @Date: 2021-07-15 14:13:14
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-27 23:27:06
-->

<template>
  <section v-loading="loading">
    <el-page-header @back="goBack" :content="title"></el-page-header>
    <div class="topic-outer xq_common_text">
      <!-- 用户基本信息 -->
      <div class="appraisal-center fonts">
        <div class="xq_common_textTitle">用户信息</div>
        <div class="innner">
          <el-row>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>用户名:</span>
                {{ emptyShow(detailData.account) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>用户ID:</span>
                {{ emptyShow(detailData.account) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>邮箱:</span>
                {{ emptyShow(detailData.account) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>年龄:</span>
                -
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>性别:</span>
                -
              </div>
            </el-col>
            <!-- <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>状态:</span>
                <span style="color: #409eff">
                  {{ detailData.status === 0 ? "正常" : "禁用" }}
                </span>
              </div>
            </el-col> -->
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>注册日期:</span>
                {{ formatDate(detailData.ctime) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>国家:</span>
                {{ emptyShow(detailData.country) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>会员状态:</span>
                -
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 订单信息 -->
        <div class="xq_common_textTitle" style="margin-top: 40px">订单信息</div>
        <div class="innner">
          <el-tabs v-model="activeTab">
            <el-tab-pane label="测评订单" name="exam">
              <el-table
                :data="detailData.examOrders"
                size="medium"
                border
                style="width: 100%"
                v-loading="loading"
              >
                <el-table-column
                  fixed
                  prop="examOrderId"
                  label="序号"
                  type="index"
                  width="70"
                ></el-table-column>
                <el-table-column label="订单号" prop="orderNumber" min-width="210">
                  <template slot-scope="scope">
                    <div style="font-weight: bold; margin-bottom: 5px; display: flex; align-items: center; justify-content: center;">
                      <el-tooltip :content="`点击复制订单号: ${scope.row.orderNumber}`" placement="bottom" effect="light">
                        <span 
                          class="clickable-order-number"
                          @click="copyOrderNumber(scope.row.orderNumber)"
                        >{{ scope.row.orderNumber }}</span>
                      </el-tooltip>
                    </div>
                    <div
                      style="
                        display: flex;
                        justify-content: center;
                        gap: 5px;
                        align-items: center;
                      "
                    >
                      <el-tag
                        type="primary"
                        size="mini"
                        v-if="scope.row.newUserOrder == 1"
                        >平台一转</el-tag
                      >
                      <el-tag
                        type="success"
                        size="mini"
                        v-if="scope.row.newUserOrder == 2"
                        >平台二转</el-tag
                      >
                      <el-tag
                        type="primary"
                        size="mini"
                        v-if="scope.row.newChannelOrder == 1"
                        >渠道一转</el-tag
                      >
                      <el-tag
                        type="success"
                        size="mini"
                        v-if="scope.row.newChannelOrder == 2"
                        >渠道二转</el-tag
                      >
                    </div>
                    <div class="sub-text">{{ formatDate(scope.row.ctime) }}</div>
                  </template>
                </el-table-column>

                <el-table-column label="测题信息" min-width="190">
                  <template slot-scope="scope">
                    <el-image
                      v-if="scope.row.logo"
                      style="width: 40px; height: 40px"
                      :src="scope.row.logo"
                      :preview-src-list="[scope.row.logo]"
                      fit="cover"
                    ></el-image>
                    <div>
                      <el-tag
                        type="success"
                        effect="dark"
                        size="mini"
                        v-if="scope.row.scheme == 'wd'"
                      >
                        维度
                      </el-tag>
                      <el-tag
                        type="primary"
                        effect="dark"
                        size="mini"
                        v-if="scope.row.scheme == 'jz'"
                      >
                        基准
                      </el-tag>
                      {{ scope.row.appExamName }}
                    </div>
                    <div class="sub-text">{{ scope.row.appExamInfoId }}</div>
                  </template>
                </el-table-column>

                <el-table-column label="渠道信息" prop="channelType" min-width="200">
                  <template slot-scope="scope">
                    <div>{{ scope.row.chanelAccountName }}</div>
                    <div class="sub-text">类型：{{ scope.row.chanelAccountType }}</div>
                    <div class="sub-text">投放方式：{{ scope.row.putWay }}</div>
                    <el-tag
                      type="primary"
                      size="mini"
                      v-if="scope.row.newChannelOrder == 1"
                      >渠道一转</el-tag
                    >
                    <el-tag
                      type="success"
                      size="mini"
                      v-if="scope.row.newChannelOrder == 2"
                      >渠道二转</el-tag
                    >
                  </template>
                </el-table-column>

                <el-table-column label="支付信息" min-width="180">
                  <template slot-scope="scope">
                    <el-tag
                      type="warning"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.payStatus == 0"
                      >待支付</el-tag
                    >
                    <el-tag
                      type="info"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.payStatus == 3"
                      >取消支付</el-tag
                    >
                    <el-tag
                      type="warning"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.payStatus == 5"
                      >支付确认中</el-tag
                    >
                    <el-tag
                      type="success"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.payStatus == 10"
                      >支付成功</el-tag
                    >
                    <el-tag
                      type="danger"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.payStatus == 15"
                      >支付失败</el-tag
                    >
                    <el-tag
                      type="warning"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.payStatus == 20"
                      >退款中</el-tag
                    >
                    <el-tag
                      type="info"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.payStatus == 25"
                      >退款完成</el-tag
                    >
                    <div>${{ emptyShow(scope.row.orderMoney) / 100 }}</div>
                    <div class="sub-text">支付方式: {{ scope.row.paymentType }}</div>

                    <div class="sub-text" v-if="scope.row.payTime">
                      完成:{{ formatDate(scope.row.payTime) }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="答题信息" min-width="200">
                  <template slot-scope="scope">
                    <div>总时长:-</div>
                    <div class="sub-text">开始时间:-</div>
                    <div class="sub-text">结束时间:-</div>
                  </template>
                </el-table-column>
                <el-table-column label="设备信息" min-width="100">
                  <template slot-scope="scope">
                    <div>设备类型:-</div>
                    <div class="sub-text">浏览器信息:-</div>
                  </template>
                </el-table-column>
                <el-table-column label="测试结果" min-width="100">
                  <template slot-scope="scope">
                    <div v-if="scope.row.resultStatus === 1">
                      <div>得分: {{ scope.row.examScore }}</div>
                      <div class="sub-text">
                        答对: {{ scope.row.rights }}/{{ scope.row.questions }}
                      </div>
                    </div>
                    <div v-else>未完成</div>
                  </template>
                </el-table-column>

                <el-table-column label="订单状态" min-width="100">
                  <template slot-scope="scope">
                    <el-tag
                      :type="scope.row.orderStatus === 1 ? 'success' : 'info'"
                      size="mini"
                    >
                      {{ scope.row.orderStatus === 1 ? "已完成" : "未完成" }}
                    </el-tag>
                    <div class="sub-text" v-if="scope.row.finishTime">
                      完成: {{ formatDate(scope.row.finishTime) }}
                    </div>
                    <div class="sub-text" v-if="scope.row.closeTime">
                      取消/关闭: {{ formatDate(scope.row.closeTime) }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="其他权益" min-width="140">
                  <template slot-scope="scope">
                    
                    <div>
                      错题集：<i
                        :class="
                          scope.row.resultStatus == 1
                            ? 'el-icon-circle-check text-success'
                            : 'el-icon-circle-close text-danger'
                        "
                      ></i>
                    </div>
                    <div>
                      免费测评码：
                      <div v-if="scope.row.freeExamCode">
                        <el-tooltip :content="`点击复制测评码: ${scope.row.freeExamCode}`" placement="bottom" effect="light">
                          <span 
                            class="clickable-order-number"
                            @click="copyContent(scope.row.freeExamCode, '测评码')"
                          >{{ scope.row.freeExamCode }}</span>
                        </el-tooltip>
                      </div>
                      <i v-else class="el-icon-circle-close text-danger"></i>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="用户信息" min-width="180">
                  <template slot-scope="scope">
                    <div>{{ scope.row.email }}</div>
                    <div v-if="scope.row.phone">{{ scope.row.phone }}</div>
                    <div class="sub-text">
                      {{ scope.row.countryCode }} / {{ scope.row.languageCode }}
                    </div>
                    <div class="sub-text">
                      {{ scope.row.ip }}
                    </div>
                    <div class="sub-text">
                      地理位置：-
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="handleViewDetail(scope.row)"
                    >
                      查看详情
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>

            <el-tab-pane label="二转订单" name="second">
              <el-table
                :data="detailData.secondPhaseOrders"
                size="medium"
                border
                style="width: 100%"
                v-loading="loading"
              >
                <el-table-column
                  fixed
                  prop="id"
                  label="序号"
                  type="index"
                  width="80"
                ></el-table-column>

                <el-table-column label="订单号" min-width="220">
                  <template slot-scope="scope">
                    <div style="font-weight: bold; margin-bottom: 5px; display: flex; align-items: center; justify-content: center;">
                      <el-tooltip :content="`点击复制订单号: ${scope.row.orderNumber}`" placement="bottom" effect="light">
                        <span 
                          class="clickable-order-number"
                          @click="copyOrderNumber(scope.row.orderNumber)"
                        >{{ scope.row.orderNumber }}</span>
                      </el-tooltip>
                    </div>
                    <div class="sub-text">测评: {{ scope.row.examOrderNumber }}</div>
                    <div class="sub-text">支付: {{ scope.row.payOrderNumber }}</div>
                    
                  </template>
                </el-table-column>

                <el-table-column label="商品信息" min-width="200">
                  <template slot-scope="scope">
                    <div>{{ scope.row.appExamName }}</div>
                    <div class="sub-text">应用ID: {{ scope.row.appExamId }}</div>
                    
                  </template>
                </el-table-column>
                <el-table-column label="渠道信息" min-width="200">
                  <template slot-scope="scope">
                    <div class="sub-text" v-if="scope.row.chanelAccountName">
                      渠道: {{ scope.row.chanelAccountName }}
                    </div>
                    <div class="sub-text">渠道类型: {{scope.row.chanelAccountType}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="订单信息" min-width="90">
                  <template slot-scope="scope">
                    <div v-if="scope.row.orderType == 'PLANS_SKU'">订阅SKU</div>
                    <div v-if="scope.row.orderType == 'SKU_PACKAGE'">方案</div>
                    <div class="sub-text" v-if="scope.row.plansSkuId">
                      SKU: {{ scope.row.plansSkuId }}
                    </div>
                    <div class="sub-text" v-if="scope.row.parentId">方案打包</div>
                  </template>
                </el-table-column>

                <el-table-column label="支付信息" min-width="180">
                  <template slot-scope="scope">
                    <el-tag
                      type="warning"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.payStatus == 0"
                      >待支付</el-tag
                    >
                    <el-tag
                      type="info"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.payStatus == 3"
                      >取消支付</el-tag
                    >
                    <el-tag
                      type="warning"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.payStatus == 5"
                      >支付确认中</el-tag
                    >
                    <el-tag
                      type="success"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.payStatus == 10"
                      >支付成功</el-tag
                    >
                    <el-tag
                      type="danger"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.payStatus == 15"
                      >支付失败</el-tag
                    >
                    <el-tag
                      type="warning"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.payStatus == 20"
                      >退款中</el-tag
                    >
                    <el-tag
                      type="info"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.payStatus == 25"
                      >退款完成</el-tag
                    >
                    <div v-if="scope.row.orderMoney">
                      支付金额: {{ scope.row.orderMoney / 100 }} {{ scope.row.currency }}
                    </div>
                    <div class="sub-text">{{ scope.row.paymentType }}</div>                   
                    <div class="sub-text" v-if="scope.row.utime">
                      更新时间: {{ formatDate(scope.row.utime) }}
                    </div>
                    <!-- <div class="sub-text">
                      创建时间: {{ formatDate(scope.row.ctime) }}
                    </div> -->
                  </template>
                </el-table-column>

                <el-table-column label="用户信息" min-width="180">
                  <template slot-scope="scope">
                    <div>{{ scope.row.email }}</div>
                    <div class="sub-text">
                      {{ scope.row.countryCode }} / {{ scope.row.languageCode }}
                    </div>
                  </template>
                </el-table-column>


                <el-table-column label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="handleViewSecondDetail(scope.row)"
                    >
                      查看详情
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>

            <el-tab-pane label="支付记录" name="payment">
              <el-table
                :data="detailData.paymentRecords"
                size="medium"
                border
                style="width: 100%"
                v-loading="loading"
              >
                <el-table-column label="关联订单" min-width="220">
                  <template slot-scope="scope">
                    <div style="font-weight: bold; margin-bottom: 5px; display: flex; align-items: center; justify-content: center;">
                      <el-tooltip :content="`点击复制支付编号: ${scope.row.payCode}`" placement="bottom" effect="light">
                        <span 
                          class="clickable-order-number"
                          @click="copyOrderNumber(scope.row.payCode)"
                        >{{ scope.row.payCode }}</span>
                      </el-tooltip>
                    </div>
                    <!-- <div class="sub-text">关联订单ID: {{ scope.row.orderPayId || '-' }}</div>
                    <div class="sub-text">关联订阅ID: {{ scope.row.subscriptionId || '-' }}</div>
                    <div class="sub-text">交易ID: {{ scope.row.transactionId || '-' }}</div> -->
                  </template>
                </el-table-column>

                <!-- <el-table-column label="用户信息" min-width="180">
                  <template slot-scope="scope">
                    <div class="sub-text">归属应用: {{ scope.row.appInfoName }}</div>
                    <div
                      class="sub-text"
                      v-if="scope.row.firstName || scope.row.lastName"
                    >
                      用户姓名: {{ scope.row.firstName || "" }}
                      {{ scope.row.lastName || "" }}
                    </div>
                    <div class="sub-text">邮箱: {{ scope.row.email }}</div>
                  </template>
                </el-table-column> -->
                <el-table-column label="渠道信息" min-width="180">
                  <template slot-scope="scope">
                    <div class="sub-text">
                      渠道账户: {{ scope.row.chanelAccountName || "-" }}
                    </div>
                    <div class="sub-text">
                      渠道类型: {{ scope.row.chanelAccountType || "-" }}
                    </div>                   
                  </template>
                </el-table-column>

                <el-table-column label="业务类型" min-width="150">
                  <template slot-scope="scope">
                    <el-tag
                      type="primary"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.bizType === '10'"
                    >
                      会员购买订单
                    </el-tag>
                    <el-tag
                      type="success"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.bizType === '20'"
                    >
                      测评购买订单
                    </el-tag>
                    <!-- <div class="sub-text">
                      支付事件类型:
                      {{ scope.row.payType === "10" ? "支付订单" : "退款订单" }}
                    </div> -->
                  </template>
                </el-table-column>

                <el-table-column label="支付方式" min-width="150">
                  <template slot-scope="scope">
                    <div>{{ scope.row.paymentType }}</div>
                    <!-- <div class="sub-text">支付方式: {{ scope.row.paymentWay }}</div> -->
                    <div class="sub-text">
                      关联商户: {{ scope.row.paymentMchId || "-" }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="支付金额" min-width="150">
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.orderMoney / Math.pow(10, scope.row.decimals) }}
                      {{ scope.row.currency }}
                    </div>                 
                  </template>
                </el-table-column>

                <el-table-column label="商品信息" min-width="180">
                  <template slot-scope="scope">
                    <div>{{ scope.row.appExamName }}</div>
                    <div class="sub-text" v-if="scope.row.skuPackageId">
                      SKU包: {{ scope.row.skuPackageId }}
                    </div>
                    <div class="sub-text" v-if="scope.row.appExamId">
                      应用ID: {{ scope.row.appExamId }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="支付状态" min-width="120">
                  <template slot-scope="scope">
                  <!-- 支付订单 -->
                    <template v-if="scope.row.payType ==10">
                    <el-tag type="warning" effect="dark" size="mini" v-if="scope.row.payStatus == 0">待支付</el-tag>
                    <el-tag type="info" effect="dark" size="mini" v-if="scope.row.payStatus == 3" >取消支付</el-tag>
                    <el-tag type="warning" effect="dark" size="mini" v-if="scope.row.payStatus == 5" >支付确认中</el-tag>
                    <el-tag type="success" effect="dark" size="mini" v-if="scope.row.payStatus == 10" >支付成功</el-tag>
                    <el-tag type="danger" effect="dark" size="mini" v-if="scope.row.payStatus == 15" >支付失败</el-tag>
                    <el-tag type="warning" effect="dark" size="mini" v-if="scope.row.payStatus == 20" >退款中</el-tag>
                    <el-tag type="info" effect="dark" size="mini" v-if="scope.row.payStatus == 25" >退款完成</el-tag>
                    </template>
                    <!-- 退款订单 -->
                    <template v-else>
                      <el-tag type="warning" effect="dark" size="mini" v-if="scope.row.payStatus == 0">待退款</el-tag>
                    <el-tag type="info" effect="dark" size="mini" v-if="scope.row.payStatus == 3" >取消退款</el-tag>
                    <el-tag type="warning" effect="dark" size="mini" v-if="scope.row.payStatus == 5" >退款确认中</el-tag>
                    <el-tag type="success" effect="dark" size="mini" v-if="scope.row.payStatus == 10" >退款成功</el-tag>
                    <el-tag type="danger" effect="dark" size="mini" v-if="scope.row.payStatus == 15" >退款失败</el-tag>
                    <el-tag type="warning" effect="dark" size="mini" v-if="scope.row.payStatus == 20" >退款中</el-tag>
                    <el-tag type="info" effect="dark" size="mini" v-if="scope.row.payStatus == 25" >退款完成</el-tag>
                    </template>
                    <div class="sub-text" v-if="scope.row.finishTime">
                      完成时间: {{ formatDate(scope.row.finishTime) }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="订单状态" min-width="100">
                  <template slot-scope="scope">
                    <el-tag
                      :type="scope.row.orderStatus === 1 ? 'success' : 'info'"
                      size="mini"
                    >
                      {{ scope.row.orderStatus === 1 ? "正常" : "异常" }}
                    </el-tag>
                  </template>
                </el-table-column>

                <el-table-column label="设备信息" min-width="180">
                  <template slot-scope="scope">
                    <div>IP: {{ scope.row.ip }}</div>
                    <div class="sub-text">
                      应用版本: {{ scope.row.appVersion || "-" }}
                    </div>
                    <!-- <div class="sub-text">设备系统: {{ scope.row.deviceOs || "-" }}</div>
                    <div class="sub-text">
                      品牌型号: {{ scope.row.brandName || "-" }}
                      {{ scope.row.deviceModel || "" }}
                    </div>
                    <div class="sub-text">
                      设备版本: {{ scope.row.deviceVersion || "-" }}
                    </div>
                    <div class="sub-text">支付场景: {{ scope.row.scene || "-" }}</div> -->
                  </template>
                </el-table-column>

                <el-table-column label="优惠信息">
                  <template slot-scope="scope">
                    <div v-if="scope.row.couponEventId">
                      <div>优惠券ID: {{ scope.row.couponEventId }}</div>
                      <div class="sub-text">
                        优惠金额:
                        {{ scope.row.couponPrice / Math.pow(10, scope.row.decimals) }}
                        {{ scope.row.currency }}
                      </div>
                    </div>
                    <div v-if="scope.row.userCouponId">
                      <div class="sub-text">用户券ID: {{ scope.row.userCouponId }}</div>
                    </div>
                    <div v-if="!scope.row.couponEventId && !scope.row.userCouponId">
                      <span class="sub-text">无优惠</span>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="时间信息" min-width="180">
                  <template slot-scope="scope">
                    <div>创建: {{ formatDate(scope.row.ctime) }}</div>
                    <div class="sub-text" v-if="scope.row.utime">
                      更新: {{ formatDate(scope.row.utime) }}
                    </div>
                    <div class="sub-text" v-if="scope.row.expireTime">
                      过期: {{ formatDate(scope.row.expireTime) }}
                    </div>
                    <div class="sub-text" v-if="scope.row.finishTime">
                      完成: {{ formatDate(scope.row.finishTime) }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="订阅信息" min-width="150">
                  <template slot-scope="scope">
                    <div v-if="scope.row.subscriptionPlanId">
                      <div>订阅计划: {{ scope.row.subscriptionPlanId }}</div>
                      <div class="sub-text">
                        启用订阅:
                        <i
                          :class="
                            scope.row.isEnableSubscriptions
                              ? 'el-icon-circle-check text-success'
                              : 'el-icon-circle-close text-danger'
                          "
                        ></i>
                      </div>
                      <div class="sub-text" v-if="scope.row.subscriptionId">
                        订阅ID: {{ scope.row.subscriptionId }}
                      </div>
                    </div>
                    <div v-else>
                      <span class="sub-text">非订阅支付</span>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="handleViewPaymentDetail(scope.row)"
                    >
                      查看详情
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>

            <el-tab-pane label="VIP记录" name="vip">
              <el-table
                :data="detailData.vipOrders"
                size="medium"
                border
                style="width: 100%"
                v-loading="loading"
              >
                <el-table-column
                  fixed
                  prop="id"
                  label="序号"
                  type="index"
                  width="80"
                ></el-table-column>

                <el-table-column label="测评题目" prop="appExamName" min-width="180"></el-table-column>
                <el-table-column label="渠道" min-width="180">
                  <template slot-scope="scope">
                    <div>{{ scope.row.chanelAccountName }}</div>
                    <div class="sub-text" v-if="scope.row.chanelAccountType">类型: {{ scope.row.chanelAccountType }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="用户信息" min-width="180">
                  <template slot-scope="scope">
                    <div>用户ID: {{ scope.row.userAccountId }}</div>
                    <div class="sub-text">应用ID: {{ scope.row.appInfoId }}</div>
                  </template>
                </el-table-column>

                <el-table-column label="应用信息" min-width="150">
                  <template slot-scope="scope">
                    <div>{{ scope.row.examApp }}</div>
                    <div class="sub-text">价格ID: {{ scope.row.priceId }}</div>
                  </template>
                </el-table-column>

                <el-table-column label="会员信息" min-width="150">
                  <template slot-scope="scope">
                    <div>等级: {{ scope.row.level }}</div>
                    <!-- <div class="sub-text">状态: 
                      <el-tag :type="getVipStatusType(scope.row.status)">
                        {{ getVipStatusText(scope.row.status) }}
                      </el-tag>
                    </div> -->
                  </template>
                </el-table-column>

                <el-table-column label="时间信息" min-width="180">
                  <template slot-scope="scope">
                    <div>订阅时间: {{ formatDate(scope.row.subscribedAt) }}</div>
                    <div class="sub-text" v-if="scope.row.expiredAt">
                      过期时间: {{ formatDate(scope.row.expiredAt) }}
                    </div>
                  </template>
                </el-table-column>

                <!-- <el-table-column label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="handleViewVipDetail(scope.row)"
                    >
                      查看详情
                    </el-button>
                  </template>
                </el-table-column> -->
              </el-table>
            </el-tab-pane>

            <el-tab-pane label="订阅记录" name="subscriptions">
              <el-table
                :data="detailData.subscriptions"
                size="medium"
                border
                style="width: 100%"
                v-loading="loading"
              >
                <el-table-column label="商品信息" min-width="180">
                  <template slot-scope="scope">
                    <div>{{ scope.row.appExamName }}</div>
                    <div class="sub-text" v-if="scope.row.chanelAccountName">
                      渠道: {{ scope.row.chanelAccountName }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="providerType"
                  label="支付类型"
                  min-width="100"
                ></el-table-column>
                <el-table-column prop="planSkuPrice" label="订阅金额" min-width="180">
                  <template slot-scope="scope">
                    <div>SKu包: ${{ emptyShow(scope.row.planSkuPrice / 100) }}</div>
                    <div>
                      使用价格: ${{ emptyShow(scope.row.planSkuTrialPrice / 100) }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="providerPlanId"
                  label="支付平台计划"
                  min-width="150"
                ></el-table-column>

                <el-table-column label="订阅状态" min-width="120">
                  <template slot-scope="scope">
                    <el-tag
                      type="primary"
                      v-if="scope.row.status === 'CREATE'"
                      size="mini"
                    >
                      创建
                    </el-tag>
                    <el-tag
                      type="success"
                      v-if="scope.row.status === 'APPROVED'"
                      size="mini"
                    >
                      买方已批准订阅
                    </el-tag>
                    <el-tag type="danger" v-if="scope.row.status === 'FILE'" size="mini">
                      失败
                    </el-tag>
                    <el-tag type="info" v-if="scope.row.status === 'OVER'" size="mini">
                      结束
                    </el-tag>
                    <el-tag
                      type="info"
                      v-if="scope.row.status === 'CANCELED'"
                      size="mini"
                    >
                      取消
                    </el-tag>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="paymentFailCount"
                  label="失败次数"
                ></el-table-column>

                <el-table-column label="下次付费" min-width="150">
                  <template slot-scope="scope">
                    {{ formatDate(scope.row.nextBillingDate) }}
                  </template>
                </el-table-column>

                <el-table-column
                  prop="trialEndDate"
                  label="试用结束日期"
                  min-width="150"
                ></el-table-column>

                <el-table-column label="时间信息" min-width="180">
                  <template slot-scope="scope">
                    <div>创建: {{ formatDate(scope.row.createdAt) }}</div>
                    <div class="sub-text" v-if="scope.row.updatedAt">
                      更新: {{ formatDate(scope.row.updatedAt) }}
                    </div>
                  </template>
                </el-table-column>

                <!-- <el-table-column label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="handleViewSubscriptionDetail(scope.row)"
                    >
                      查看详情
                    </el-button>
                  </template>
                </el-table-column> -->
              </el-table>
            </el-tab-pane>

            <el-tab-pane label="订阅流水" name="subscriptionFlows">
              <el-table
                :data="detailData.subscriptionFlows"
                size="medium"
                border
                style="width: 100%"
                v-loading="loading"
              >
                <el-table-column label="关联订单" min-width="220">
                  <template slot-scope="scope">
                    <div style="font-weight: bold; margin-bottom: 5px; display: flex; align-items: center; justify-content: center;">
                      <el-tooltip :content="`点击复制支付编号: ${scope.row.payCode}`" placement="bottom" effect="light">
                        <span 
                          class="clickable-order-number"
                          @click="copyOrderNumber(scope.row.payCode)"
                        >{{ scope.row.payCode }}</span>
                      </el-tooltip>
                    </div>
                    <!-- <div class="sub-text">关联订单ID: {{ scope.row.orderPayId || '-' }}</div>
                    <div class="sub-text">关联订阅ID: {{ scope.row.subscriptionId || '-' }}</div>
                    <div class="sub-text">交易ID: {{ scope.row.transactionId || '-' }}</div> -->
                  </template>
                </el-table-column>
                <el-table-column label="商品信息" min-width="180">
                  <template slot-scope="scope">
                    <div>{{ scope.row.appExamName }}</div>
                    <div class="sub-text" v-if="scope.row.chanelAccountName">
                      渠道: {{ scope.row.chanelAccountName }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="planSkuPrice" label="订阅金额" min-width="180">
                  <template slot-scope="scope">
                    <div>SKu包: ${{ emptyShow(scope.row.planSkuPrice / 100) }}</div>
                    <div>
                      使用价格: ${{ emptyShow(scope.row.planSkuTrialPrice / 100) }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="email"
                  label="邮箱"
                  min-width="180"
                ></el-table-column>

                <el-table-column
                  label="支付平台"
                  prop="providerType"
                  min-width="100"
                ></el-table-column>

                <el-table-column label="流水类型" min-width="80">
                  <template slot-scope="scope">
                    <el-tag
                      type="primary"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.flowType === 'INITIAL'"
                    >
                      初始订阅
                    </el-tag>
                    <el-tag
                      type="success"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.flowType === 'RENEWAL'"
                    >
                      续费
                    </el-tag>
                    <el-tag
                      type="warning"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.flowType === 'REFUND'"
                    >
                      退款
                    </el-tag>
                    <el-tag
                      type="danger"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.flowType === 'CANCEL'"
                    >
                      取消
                    </el-tag>
                    <!-- <div class="sub-text">支付方式: {{ scope.row.paymentMethod || '-' }}</div> -->
                  </template>
                </el-table-column>

                <el-table-column label="流水状态" min-width="90">
                  <template slot-scope="scope">
                    <el-tag
                      type="success"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.flowStatus === 'SUCCESS'"
                    >
                      成功
                    </el-tag>
                    <el-tag
                      type="danger"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.flowStatus === 'FAILED'"
                    >
                      失败
                    </el-tag>
                    <el-tag
                      type="warning"
                      effect="dark"
                      size="mini"
                      v-if="scope.row.flowStatus === 'PENDING'"
                    >
                      处理中
                    </el-tag>
                    <div class="sub-text" v-if="scope.row.failCount > 0">
                      失败次数: {{ scope.row.failCount }}
                    </div>
                    <div class="sub-text" v-if="scope.row.failReason">
                      失败原因: {{ scope.row.failReason }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="金额信息" min-width="110">
                  <template slot-scope="scope">
                    <div style="font-weight: bold">
                      {{ emptyShow(scope.row.amount ? scope.row.amount / 100 : 0) }}
                      {{ scope.row.currency }}
                    </div>
                    <div class="sub-text">
                      续费期数: {{ scope.row.renewalNumber || 0 }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="计费周期" min-width="190">
                  <template slot-scope="scope">
                    <!-- <div>周期: {{ scope.row.billingCycle || '-' }} 天</div> -->
                    <div class="sub-text" v-if="scope.row.billingStartTime">
                      开始: {{ formatDate(scope.row.billingStartTime) }}
                    </div>
                    <div class="sub-text" v-if="scope.row.billingEndTime">
                      结束: {{ formatDate(scope.row.billingEndTime) }}
                    </div>
                    <div class="sub-text" v-if="scope.row.nextBillingTime">
                      下次计费: {{ formatDate(scope.row.nextBillingTime) }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="时间信息" min-width="180">
                  <template slot-scope="scope">
                    <div>创建: {{ formatDate(scope.row.ctime) }}</div>
                    <div class="sub-text" v-if="scope.row.utime">
                      更新: {{ formatDate(scope.row.utime) }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="handleViewSubscriptionFlowDetail(scope.row)"
                    >
                      查看详情
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { isEmpty, emptyShow } from "../../utils/tools/index";
import { formatDate } from "@/utils/filters/filter";
export default {
  data() {
    return {
      emptyShow,
      isEmpty,
      title: "",
      detailData: [],
      loading: false,
      activeTab: "exam", // 可选值: exam, second, extra, payment, vip
      formatDate,
    };
  },
  created() {
    this.getOrgData();
  },
  methods: {
    /* 返回上一页 */
    goBack() {
      this.$router.go(-1);
    },

    /* 获取用户详情数据 */
    async getOrgData() {
      this.loading = true;
      this.title = this.$route.query.title;

      const { data: res } = await this.$get(
        `/user/list/detail?email=${JSON.parse(this.$route.query.value)}`
      );
      if (res.data) this.detailData = res.data;
      this.loading = false;
    },

    /* 查看订单详情 */
    handleViewDetail(row) {
      this.$router.push({
        name: "ORDER_DETAIL",
        query: {
          id: 0,
          title: "测评订单",
          key: "orderNumber",
          value: JSON.stringify(row.orderNumber),
          path: "/exam/order/info",
        },
      });
    },

    /* 查看二转订单详情 */
    handleViewSecondDetail(row) {
      this.$router.push({
        name: "SECOND_ORDER_DETAIL",
        query: {
          id: 2,
          title: "支付订单",
          key: "payCode",
          value0: JSON.stringify(row.examOrderNumber),
          value: JSON.stringify(row.orderNumber),
          path: `/secondPhase/order/info/${row.id}`,
        },
      });
    },

    /* 查看支付记录详情 */
    handleViewPaymentDetail(row) {
      this.$router.push({
        name: "ORDER_DETAIL",
        query: {
          id: 2,
          title: "支付订单",
          key: "payCode",
          value: JSON.stringify(row.payCode),
          path: "/pay/order/info",
        },
      });
    },

    /* 查看VIP记录详情 */
    handleViewVipDetail(row) {
      this.$router.push({
        name: "ORDER_DETAIL",
        query: {
          id: 0,
          title: "VIP记录",
          key: "orderNumber",
          value: JSON.stringify(row.orderNumber),
          path: "/vip/info",
        },
      });
    },

    /* 查看订阅记录详情 */
    handleViewSubscriptionDetail(row) {
      this.$router.push({
        name: "ORDER_DETAIL",
        query: {
          id: 0,
          title: "订阅记录",
          key: "subscriptionCode",
          value: JSON.stringify(row.subscriptionCode),
          path: "/subscription/info",
        },
      });
    },

    /* 查看Plans记录详情 */
    handleViewPlanDetail(row) {
      this.$router.push({
        name: "ORDER_DETAIL",
        query: {
          id: 0,
          title: "Plans记录",
          key: "id",
          value: JSON.stringify(row.id),
          path: "/plans/info",
        },
      });
    },

    /* 查看订阅流水详情 */
    handleViewSubscriptionFlowDetail(row) {
      this.$router.push({
        name: "ORDER_DETAIL",
        query: {
          id: 2,
          title: "支付订单",
          key: "payCode",
          value: JSON.stringify(row.orderNumber),
          path: "/pay/order/info",
        },
      });
    },

    /* 获取订阅状态类型 */
    getSubscriptionStatusType(status) {
      if (status === "active") return "success";
      if (status === "canceled" || status === "expired") return "danger";
      if (status === "trialing") return "warning";
      if (status === "past_due") return "warning";
      return "info";
    },

    /* 获取支付状态类型 */
    getPayStatusType(status) {
      if (status === 10) return "success";
      if (status === 15) return "danger";
      if (status === 3) return "info";
      if (status === 0 || status === 5 || status === 20) return "warning";
      if (status === 25) return "info";
      return "info";
    },

    /* 获取支付状态文本 */
    getPaymentStatusText(status) {
      const statusMap = {
        0: "待支付/退款",
        3: "取消支付/退款",
        5: "支付/退款确认中",
        10: "支付/退款成功",
        15: "支付/退款失败",
        20: "退款中",
        25: "退款完成",
      };
      return statusMap[status] || "未知状态";
    },

    /* 获取VIP状态类型 */
    getVipStatusType(status) {
      if (status === 1) return "success";
      if (status === 0) return "danger";
      return "info";
    },

    /* 获取VIP状态文本 */
    getVipStatusText(status) {
      const statusMap = {
        0: "未激活",
        1: "已激活",
        2: "已过期",
      };
      return statusMap[status] || "未知状态";
    },

    /* 格式化时间戳 */
    formatTimestamp(timestamp) {
      if (!timestamp) return "-";
      return formatDate(timestamp);
    },

    /* 获取订阅流水状态类型 */
    getFlowStatusType(status) {
      if (status === "SUCCESS") return "success";
      if (status === "FAILED") return "danger";
      if (status === "PENDING") return "warning";
      return "info";
    },

    /* 获取业务类型文本 */
    getBizTypeText(bizType) {
      const typeMap = {
        10: "会员购买订单",
        20: "测评购买订单",
      };
      return typeMap[bizType] || "其他";
    },

    /* 获取支付类型文本 */
    getPayTypeText(payType) {
      const typeMap = {
        10: "支付订单",
        20: "退款订单",
      };
      return typeMap[payType] || "其他";
    },

    /* 获取流水类型文本 */
    getFlowTypeText(flowType) {
      const typeMap = {
        INITIAL: "初始订阅",
        RENEWAL: "续费",
        REFUND: "退款",
        CANCEL: "取消",
      };
      return typeMap[flowType] || "未知类型";
    },

    /* 获取流水类型标签类型 */
    getFlowTypeTagType(flowType) {
      if (flowType === "INITIAL") return "primary";
      if (flowType === "RENEWAL") return "success";
      if (flowType === "REFUND") return "warning";
      if (flowType === "CANCEL") return "danger";
      return "info";
    },

    /* 获取流水状态文本 */
    getFlowStatusText(status) {
      const statusMap = {
        SUCCESS: "成功",
        FAILED: "失败",
        PENDING: "处理中",
      };
      return statusMap[status] || "未知状态";
    },

    /* 复制内容（指定类型） */
    copyContent(content, contentType = '内容') {
      // 现代浏览器使用 Clipboard API
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(content).then(() => {
          this.$message.success(`${contentType} ${content} 已复制到剪贴板`);
        }).catch(() => {
          this.fallbackCopyTextToClipboard(content, contentType);
        });
      } else {
        // 降级到传统方法
        this.fallbackCopyTextToClipboard(content, contentType);
      }
    },

    /* 复制订单号 */
    copyOrderNumber(content) {
      // 根据内容特征判断类型
      let contentType = '内容';
      if (content && typeof content === 'string') {
        if (content.includes('PAY_') || content.includes('pay_')) {
          contentType = '支付编号';
        } else if (content.includes('ORDER_') || content.includes('order_')) {
          contentType = '订单号';
        } else if (content.length === 8 && /^[A-Z0-9]+$/.test(content)) {
          // 8位大写字母数字组合，可能是测评码
          contentType = '测评码';
        } else if (content.includes('EXAM_') || content.includes('exam_')) {
          contentType = '订单号';
        } else {
          // 默认根据长度和格式判断
          if (content.length > 20) {
            contentType = '订单号';
          } else if (content.length <= 10) {
            contentType = '测评码';
          } else {
            contentType = '编号';
          }
        }
      }
      
      // 调用通用复制方法
      this.copyContent(content, contentType);
    },

    /* 降级复制方法 */
    fallbackCopyTextToClipboard(text, contentType = '内容') {
      const input = document.createElement('input');
      input.value = text;
      input.style.position = 'fixed';
      input.style.left = '-999999px';
      input.style.top = '-999999px';
      document.body.appendChild(input);
      input.focus();
      input.select();
      
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.$message.success(`${contentType} ${text} 已复制到剪贴板`);
        } else {
          this.$message.error('复制失败，请手动复制');
        }
      } catch (err) {
        this.$message.error('复制失败，请手动复制');
      }
      
      document.body.removeChild(input);
    },
  },
};
</script>

<style lang="scss" scoped>
.topic-outer {
  width: 100%;
  overflow: hidden;
  margin-top: 10px;

  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    .el-col {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .appraisal-center {
    margin: 20px 0;
    border-radius: 6px;
    background: #fff;
    padding: 30px 20px;

    .xq_common_textTitle {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 20px;
    }

    .innner {
      padding: 20px 20px 0;

      .grid-content {
        color: #888;

        span:first-child {
          color: #444;
          margin-right: 10px;
        }
      }
    }
  }
}

::v-deep .el-table th,
::v-deep .el-table td {
  text-align: center !important;
}

::v-deep .el-page-header__content {
  font-size: 16px;
  color: #303133;
}

.sub-text {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}

::v-deep .el-table {
  .el-table__header th {
    background-color: #f5f7fa;
    color: #606266;
  }

  .el-image {
    border-radius: 4px;
    overflow: hidden;
  }
}

.text-success {
  color: #67c23a;
}

.text-danger {
  color: #f56c6c;
}

/* 可点击订单号样式 */
.clickable-order-number {
  cursor: pointer;
  color: #409eff;
  transition: all 0.3s;
  border-radius: 3px;
  padding: 2px 4px;
  
  &:hover {
    color: #337ecc;
    background-color: #ecf5ff;
    text-shadow: 0 0 3px rgba(64, 158, 255, 0.3);
  }
  
  &:active {
    color: #2a6cb8;
    background-color: #d9ecff;
  }
}
</style>
